var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.path.length)?_c('div',{class:['bg-cover bg-center bg-norepeat', _vm.imageSize[_vm.size]],style:({ 'background-image': 'url(' + _vm.path + ')' })}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }